module.exports = __webpack_public_path__ + "static/sunkenforest@fiferries.d551c3d5.jpg";